export default __webpack_public_path__ + "img/comprobante-800.2182808a.jpg";